import { Controller } from "@hotwired/stimulus"

// Soumet le formulaire dès qu'un champ change.
// Usage : <form data-controller="auto-submit" data-action="change->auto-submit#submit">
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
